import React from 'react'
import { ScreenLayout } from '../shared/ui/ScreenLayout'
import { SingleDaySelector } from '../shared/ui/SingleDaySelector'
import { CustomSteps } from './screenAppointmentsList/CustomSteps'
import { ResourcePicker } from './screenAppointmentsList/ResourcePicker'
import { CalendarOutline } from 'antd-mobile-icons'
import { Divider, Calendar } from 'antd-mobile'
import { observer } from 'mobx-react'
import { t } from '../../config/i18n'
import { useAppointmentsListScreenController } from '../../hooks/useAppointmentsListScreenController'

const getFirstDayOfWeek = (locale: string) => {
  const localeFirstDayMap: Record<string, 'Monday' | 'Sunday' | undefined> = {
    'he': 'Sunday',
    'ru': 'Monday',
  }
  return localeFirstDayMap[locale] ?? 'Sunday'
}

export const ScreenAppointmentsList = observer(() => {
  const {
    data: {
      date,
      stepsItems,
      stepsCurrent,
      isAggregated,
      partialLoadMessages,
      resourcesByBusinessId,
      businessesById,
      selectedResourceId,
      selectedBusinessId,
      hasResources
    },
    ui: { datePickerOpen, openDatePicker, closeDatePicker },
    actions: { changeDate, swapAppointments, selectAllResources, selectResource },
    status,
    navigation: { openAppointment },
  } = useAppointmentsListScreenController()

  return (
    <ScreenLayout
      title={t.appointment.list}
      loading={status.loading}
      footer=''
      actionIcon={<div onClick={openDatePicker}><CalendarOutline/></div>}
      onAction={() => {}}
    >
      {datePickerOpen ? (
        <Calendar
          selectionMode='single'
          defaultValue={date}
          onChange={(d: Date | null) => {
            closeDatePicker()
            changeDate(d || new Date())
          }}
          weekStartsOn={getFirstDayOfWeek(t.antd.locale)}
        />
      ) : (
        <>
          <SingleDaySelector value={date} onChange={changeDate}/>
          <div className='mt2'></div>
          {hasResources && (
            <ResourcePicker
              selectedResourceId={selectedResourceId}
              selectedBusinessId={selectedBusinessId}
              resourcesByBusinessId={resourcesByBusinessId}
              businessesById={businessesById}
              onSelectAll={selectAllResources}
              onSelectResource={selectResource}
            />
          )}
          {partialLoadMessages && (
            <div className='pa3 mb2 br2' style={{ backgroundColor: '#fff4e6', color: '#663c00' }}>
              <div className='bold'>{t.appointment.partialLoadWarning}</div>
              <div>{partialLoadMessages}</div>
            </div>
          )}
          {!status.loading && (
            <>
              <Divider className='bold'>{t.client.list}</Divider>
              <CustomSteps
                current={stepsCurrent}
                onItemClick={openAppointment}
                onItemDragAndDropChange={swapAppointments}
                dragEnabled={!isAggregated}
                items={stepsItems}
              />
            </>
          )}
        </>
      )}
    </ScreenLayout>
  )
})
